import { axiosInstance } from "@/helper/axios-instance";
import { DataAwareResponse } from "@/types/types";
import { useQueryWithValidation } from "./useQueryWithValidation";

type StockInfo = {
  id: string;
  stock: string;
  timestamp: string;
  value: number;
};

export function useStockPrice(ticker: string | undefined) {
  return useQueryWithValidation({
    queryKey: ["stock-price", String(ticker)],
    queryFn: async () => {
      const { data } = await axiosInstance({
        method: "GET",
        url:  `StockPriceRegister/GetPrice/${ticker}`,
      });

      return data as DataAwareResponse<StockInfo>;
    },
    enabled: !!ticker,
  });
}
